import { Component, ViewEncapsulation, OnInit, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { NGXLogger } from 'ngx-logger';
import { TableauService } from '@supoui/core/services/tableau.service';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Error } from '../error-message/error-message.component';
import { TranslateService } from '@ngx-translate/core';

declare var tableau: any;

@Component({
    selector: 'app-tableau',
    templateUrl: './tableau.component.html',
    styleUrls: ['tableau.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
@UntilDestroy({ checkProperties: true })
export class TableauComponent implements OnInit {
  @Input() target: string;
  @Input() view: string;
  @Input() profile: string;
  @Input() width: string;
  @Input() height: string;

  ticket: string;
  error: any;
  viz: any = null;
  defaultSize = { width: '800', height: '600' };
  loaded = false;

  constructor(private tableauService: TableauService, private translateService: TranslateService, private logger: NGXLogger) {}

  ngOnInit(): void {
    this.fetchTicket().subscribe(
      () => this.initViz(this.target, this.view, this.ticket),
      err => {
        this.logger.debug('Error fetching ticket!', err);
        this.error = err;
      }
    );
  }

  private fetchTicket(): Observable<string> {
    return this.tableauService.getTicket(this.profile).pipe(
      tap(response => {
        this.ticket = response;
        if (this.ticket === '-1') {
          throw new Error(this.translateService.instant('Error fetching ticket!'));
        }
      })
    );
  }

  private initViz(target: string, view: string, ticket: string): void {
    const containerDiv = document.getElementById('vizContainer');
    const vizUrl = `${this.getHost()}/services/sosreport/trusted/${ticket}/t/${target}/views/${view}`;

    // @ts-ignore
    const options: tableau.VizCreateOptions = {
      width: this.width ? this.width : containerDiv?.offsetWidth ? containerDiv.offsetWidth.toString() : this.defaultSize.width,
      height: this.height ? this.height : containerDiv?.offsetHeight ? containerDiv.offsetHeight.toString() : this.defaultSize.height,
      hideTabs: false,
      hideToolbar: true,
      // @ts-ignore
      onFirstInteractive: (ev: tableau.TableauEvent) => {
        this.logger.debug('TableauEvent:', ev);
      },
      // @ts-ignore
      onFirstVizSizeKnown: (ev: tableau.VizResizeEvent) => {
        this.loaded = true;
        this.logger.debug('VizResizeEvent:', ev);
      }
    };
    if (this.viz != null) {
      // viz is undefined on both the first and second page loads - even though second page load throws a 'viz already present' error
      this.viz.dispose();
    }

    try {
      if (!containerDiv) {
        throw new Error(this.translateService.instant('Tableau vizContainer element not found!'));
      }
      this.viz = new tableau.Viz(containerDiv, vizUrl, options);
    } catch (err) {
      this.logger.error(err);
      this.error = err;
    }
  }

  private getHost(): string {
    return window.location.port ? `http://${window.location.hostname}:${window.location.port}` : `https://${window.location.hostname}`;
  }
}
